/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { unauthorizedSchema } from "./unauthorizedSchema.ts";

export const userConsent18CreateStatus200Schema = z.any();

export const userConsent18CreateStatus401Schema = unauthorizedSchema.describe("Сериализатор 401 ошибки - для документации.");

export const userConsent18CreateResponseSchema = z.union([userConsent18CreateStatus200Schema, userConsent18CreateStatus401Schema]);
